import { useState, useEffect, useCallback } from 'react';
import { apiClient } from '../lib/api-client.js';
import { useAuth } from '../features/auth/useAuth.js';

export function useNotificationBadge() {
  const { dbUser } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);

  const fetchCount = useCallback(async () => {
    if (!dbUser) return;
    try {
      const res = await apiClient.get<{ count: number }>('/notifications/unread-count', {
        requireAuth: true,
      });
      setUnreadCount(res.count);
    } catch {
      // バッジ取得失敗は無視（UXに影響しないため）
    }
  }, [dbUser]);

  // マウント時のみ取得
  useEffect(() => {
    fetchCount();
  }, [fetchCount]);

  return { unreadCount, refetch: fetchCount };
}
